import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-down', 'ChevronsDown', [["path",{"d":"M7 7l5 5l5 -5"}],["path",{"d":"M7 13l5 5l5 -5"}]]);